import {
  ChangeDetectionStrategy, ChangeDetectorRef,
  Component, Input, OnInit, ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import * as _ from 'lodash';

import { AccountInformationService } from '../../account-information.service';
import { InformationPageService } from '../../../information-page/information-page.service';
import { BrandService } from 'shared/brand/brand.service';
import { TradeInfoService } from 'shared/trade-info/trade-info.service';
import { BaseAccountSegmentComponent } from '../base/_base-segment.component';
import { TRADE_INFO_NAME } from '../../variables';
import { TradeInfoFormComponent } from './trade-info-form.component';
import { PermissionsService } from 'shared/permissions/permissions.service';
import {ProductPanelComponent} from '../../../../product-panel/product-panel.component';


@Component({
  moduleId: module.id,
  selector: 'trade-info-segment',
  template: `
    <trade-info-form
      [data]='data'
      [segmentData]='segmentData'>
    </trade-info-form>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TradeInfoComponent extends BaseAccountSegmentComponent implements OnInit {
  name: string = TRADE_INFO_NAME;
  brandId: string;

  @ViewChild(TradeInfoFormComponent, {static: false})
  // @ts-ignore
  protected formComponent: TradeInfoFormComponent | void;

  constructor(
    protected accountInformationService: AccountInformationService,
    protected informationPageService: InformationPageService,
    protected ref: ChangeDetectorRef,
    private brandService: BrandService,
    private tradeInfoService: TradeInfoService,
  ) {
    super(
      accountInformationService,
      informationPageService,
      ref,
    );
  }

  /*******************************************
   * COMPONENT HOOKS
   *******************************************/

  ngOnInit() {
    super.ngOnInit();
    this.brandId = this.brandService.getBrand();
    this.refresh();
  }

  /*******************************************
   * COMPONENT PUBLIC METHODS
   *******************************************/

  fetchFormData(): Observable<any> {
    return this.tradeInfoService.fetch(this.brandId);
  }

  putFormData(): Observable<any> {
    if (!this.formComponent) {
      return;
    }
    const data = this.formComponent.form.value;
    return this.tradeInfoService.put(this.brandService.getBrand(), data);
  }

  /*******************************************
   * COMPONENT PRIVATE METHODS
   *******************************************/

  private prepareDataForSave(data: Array<any>) {
    return _.map(data, (item: any) => _.omit(item, 'brandName', 'aaiaId'));
  }

}
